"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { sendGAEvent } from "@next/third-parties/google";

const gaId = process.env.NEXT_PUBLIC_GA_ID?.trim();

/**
 * Initial page_view comes from `<GoogleAnalytics />` config.
 * This fires on subsequent App Router client navigations.
 */
export function GoogleAnalyticsRouteTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirst = useRef(true);

  useEffect(() => {
    if (!gaId) return;
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    const qs = searchParams?.toString();
    const pagePath = qs ? `${pathname}?${qs}` : pathname;
    sendGAEvent("config", gaId, { page_path: pagePath });
  }, [pathname, searchParams]);

  return null;
}
